import { hasCalendarDateStarted } from '@utils/datetime';
import { ILEExamSession, Testlet, TestletStatus } from '../types';

export type DefaultTestLanding = { kind: 'testlet'; testSessionId: number; testletId: number } | { kind: 'scores'; testSessionId: number };

export const getFirstNotLockedTestlet = (testSessions: ILEExamSession[] | undefined): Testlet | null => {
  if (!testSessions) {
    return null;
  }

  let testlet: Testlet | null = null;
  testSessions.forEach((testSession) => {
    if (testlet) {
      return;
    }
    testSession.testlets.forEach((currentTestlet) => {
      if (testlet) {
        return;
      }
      if (currentTestlet.status === TestletStatus.LOCKED || currentTestlet.status === TestletStatus.COMPLETED) {
        return;
      }
      testlet = currentTestlet;
    });
  });
  if (!testlet && testSessions.length > 0 && testSessions[testSessions.length - 1].testlets.length > 0) {
    return null;
  }
  return testlet;
};

/**
 * Tests-tab default only. Skip sessions whose start_date is still in the future,
 * then reuse the first-not-locked walk on the sessions that have already started.
 */
export const getDefaultTestLanding = (testSessions: ILEExamSession[] | undefined): DefaultTestLanding | null => {
  if (!testSessions?.length) {
    return null;
  }

  const eligible = testSessions.filter((session) => session.start_date && hasCalendarDateStarted(session.start_date));

  if (eligible.length === 0) {
    return { kind: 'scores', testSessionId: testSessions[0].id };
  }

  const testlet = getFirstNotLockedTestlet(eligible);
  if (testlet) {
    return {
      kind: 'testlet',
      testSessionId: testlet.exam_session,
      testletId: testlet.id,
    };
  }

  return { kind: 'scores', testSessionId: eligible[eligible.length - 1].id };
};
